import * as angular from 'angular';
import * as template from './template.html';
import './styling.scss';

const module = angular.module('coverage-section-list', []);

interface CoverageSectionListController extends angular.IStrictController {
    handleClickExpand: (event: JQueryEventObject) => void;
}

module.component('coverageSectionList', {
    template: template,
    bindings: {
        coverages: '<'
    },
    controller: function(this: CoverageSectionListController, $element: angular.IAugmentedJQuery) {
        'ngInject';

        this.handleClickExpand = (event: JQueryEventObject) => {
            event.currentTarget.classList.toggle('expanded');
        };
    }
});

export { module };
